import WeatherCardReveal from "@/components/game/WeatherCardReveal";
import { areaText } from "@/components/game/WeatherFlow";

// WEATHER OVERLAY — every screen, the same draw (server time): the weather card turns over in the
// middle of the screen over a soft dimmed backdrop (the board stays visible around it), then the
// global card next to it turns over too. After that the overlay fades out and the area reveal on
// the board starts. timeline: useWeatherTimeline.
export default function WeatherOverlay({ game, faces, timeline }) {
  if (!timeline?.overlay) return null;
  const ws = game.weather_state;
  const fading = timeline.overlayFading;
  const areaLine = !ws ? "" : ws.kind === "none" ? "Nothing happens this round." : areaText(ws, faces).split(". ")[0] + ".";
  return (
    <div
      data-testid="weather-overlay"
      data-phase={timeline.phase}
      className="absolute inset-0 flex items-center justify-center"
      style={{ zIndex: 60, background: "rgba(42,46,44,0.28)", opacity: fading ? 0 : 1, transition: "opacity 350ms ease", pointerEvents: fading ? "none" : "auto" }}
    >
      <div
        className="flex flex-col items-center"
        style={{ width: 440, padding: "18px 22px 20px", gap: 12, borderRadius: 16, background: "var(--card)", boxShadow: "0 18px 50px rgba(36,40,38,.28)", border: "1px solid var(--line)" }}
      >
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "var(--ink-4)" }}>
          End of round {game.round} · the weather
        </div>
        <WeatherCardReveal ws={ws} timeline={timeline} areaLine={areaLine} />
      </div>
    </div>
  );
}
